import { Component, OnInit, Inject,OnDestroy,ViewEncapsulation,ViewChild} from '@angular/core';
import { Validators, FormGroup, FormControl} from '@angular/forms';
import { MAT_DIALOG_DATA} from '@angular/material';
import { MatDialogRef, MatSelect,MatOption,MatDialog} from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Subscription, Subject } from 'rxjs';
import {enumAlertType, enumNotifyTypeItem, enumNotifyTypeText,appsettings} from '../../../app-settings';
import { notificationService } from '../notification.service';
import { NotificationForCreationResponse,NotifyType,getRoleIndividualList, AddNotification, notifyTypeItem, checkAlertItem} from '../notification';
import { RollbarService } from '../../../rollbar';
import * as Rollbar from 'rollbar'
import { SessionCheck,generateAlertMessage,AuthFailedMessage } from '../../../app-general';
import {Router} from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { AlertSharedService } from '../../../_services/index';
import { ConfirmMessageComponent } from '../../../confirm-message/confirm-message.component';
import { ApiService } from '../../../api.service';
import { DOCUMENT } from '@angular/platform-browser';

@Component({
  selector: 'app-add-notification',
  templateUrl: './add-notification.component.html',
  providers: [ notificationService],
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./add-notification.component.scss']
})
export class AddNotificationComponent implements OnInit,OnDestroy {

  watcher: Subscription;
  columns: number = 8;
  notifytype="";
  notifytypeItem;
  CampusId; 
  
  AlarmId;
  AlarmSubTypeId=0;
  Escalationlevel; 
  SiteId = "1";
  public notificationCreationForm : FormGroup; 
  RoleIndividualList:getRoleIndividualList[];
  NotifyType:NotifyType[]=[{Notifytype:'Individual',NotifytypeId:1},{Notifytype:'Role (Global)',NotifytypeId:0},{Notifytype:'Staff Group',NotifytypeId:2},{Notifytype:'Resident Group',NotifytypeId:3}]; 
  campusName;
  addNotifyflag : boolean = true;
  BuildingId;
  FloorId;
  SubZoneId;
  selectedBuildingName;
  selectedFloorName;  
  selectedSubZoneName;
  // chkEscalateyesvalue:boolean = true;
  // chkEscalatenovalue:boolean = false;
  
  checkEscalate:boolean = false;
  checkRepeatLevel:boolean = false;
  Escalatevalue;
  RepeatLevelvalue;
  TimeEscalatevalue;
  RepeatCyclevalue;
  RepeatNumbervalue;
  AlarmSubType_Name;
  eventName;
  public EnumAlertType = enumAlertType;
  showNotifyWarningImage = false;
  AlertId;
  private _onDestroy: Subject<void> = new Subject<void>();
  EscalateInfoTooltip = "When Repeat Level Disabled, the Time to Escalate value can be manually entered once Escalate is enabled.\n\n When Repeat Level Enabled, " +
                        "Time to Escalate is auto-calculated with the value equal to (Repeat Number * Repeat Cycle) + Repeat Cycle, once Escalate is enabled. ";
  NotificationLevelTooltip = "WARNING: Previous notification level(s) has/have not been setup to escalate.For this level to execute,edit previous level.";
  constructor(private router: Router,mediaObserver: MediaObserver,public thisDialogRef: MatDialogRef<AddNotificationComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
  private notificationService: notificationService,@Inject(RollbarService) private rollbar: Rollbar,private apiService: ApiService, 
  private alertSharedService: AlertSharedService,public dialog: MatDialog,@Inject(DOCUMENT) private document: any) 
  {      
      
      this.CampusId = data.CampusId;
      this.AlarmId = data.AlarmId;
      this.Escalationlevel = data.EscalationLevel;
      if (data.AlarmSubTypeId>0)
        this.AlarmSubTypeId = data.AlarmSubTypeId;
      this.campusName = data.CampusName;
      this.BuildingId = data.BuildId;
      this.FloorId = data.FloorId;
      this.SubZoneId = data.SubZoneId;
      this.AlertId = data.AlertId;
      this.AlarmSubType_Name = data.AlarmSubTypeName;
      if(this.BuildingId > 0 || this.BuildingId != null)
        this.selectedBuildingName = data.BuildingName;
      else
        this.selectedBuildingName = "";  
        
      if(this.FloorId > 0 || this.FloorId != null)
        this.selectedFloorName = data.FloorName;
      else
        this.selectedFloorName = ""; 
        
      if(this.SubZoneId > 0 || this.SubZoneId != null)  
        this.selectedSubZoneName = data.SubZoneName;
      else
        this.selectedSubZoneName = ""; 
        
      this.eventName = data.AlarmNameId;
      
      this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
        if (change) {
          if (change.mqAlias == 'xs') {
            this.columns = 3;
            this.notifytype = "Role (Global)";
          } 
          else if (change.mqAlias == 'sm') {
            this.columns = 4;
          }         
          else {
            this.columns = 8;
          }
        }
      });
  }

  ngOnInit() 
  {

    this.notificationCreationForm = new FormGroup({
        escalation: new FormControl('', []),                    
        TimeToEscalate: new FormControl('', [Validators.required,Validators.min(1),Validators.pattern(appsettings.Number_Pattern)]),   
        RepeatLevelNumber: new FormControl('', [Validators.required,Validators.min(1),Validators.pattern(appsettings.Number_Pattern)]),   
        RepeatLevelCycle: new FormControl('', [Validators.required,Validators.min(1),Validators.pattern(appsettings.Number_Pattern)]), 
        notify: new FormControl('', [Validators.required]),       
        NotifyList: new FormControl('', [Validators.required])      
        });
              
        this.notificationCreationForm.get('RepeatLevelNumber').disable();
        this.notificationCreationForm.get('RepeatLevelCycle').disable();
        this.notificationCreationForm.get('TimeToEscalate').disable();   
        if(this.Escalationlevel > 1)
          this.getNotifyRepeatEscalateLevel()     
  } 
  
  getNotifyRepeatEscalateLevel()
  {
    try
    {
      var notifyType_Item : any =
      {
        siteId:this.SiteId,
        authKey: localStorage.getItem("Authkey"),
        level:this.Escalationlevel,
        alertId:this.AlertId
      }   
      this.notificationService.getNotifyRepeatEscalateLevels(notifyType_Item).pipe(takeUntil(this._onDestroy))
      .subscribe((EscalationsLevel : any[])=>{        
         console.log(EscalationsLevel)
         if(EscalationsLevel[0].NeedRepeat == 1 && EscalationsLevel[0].NeedEscalate == 0)
          this.showNotifyWarningImage = true;
      });
    }
    catch (err) {
      throw new Error('edit-notification.component.ts' + ' - getNotificationLevels() - ' + err.message);
    }
  }
  
  handleInput(event) 
  {
    try
    {
      var n = event.target.value.lastIndexOf(" ");
      var l = event.target.value.length;
      var changedValue = event.target.value;
      if (event.which == 32 && changedValue.trim().length == 0) {
        changedValue = changedValue.trim();
      }
      else if (event.which == 32) {
        if (n + 1 == l) {
          changedValue = changedValue.trim() + " ";
        }
        else {
          changedValue = changedValue.trim();
        }
      }
      Object.keys(this.notificationCreationForm.controls).forEach(field => { // {1}
        const control = this.notificationCreationForm.get(field); // {2}
        if (field == document.getElementById(event.target.id).getAttribute("formControlName")) {
          control.setValue(changedValue);
          control.markAsTouched({ onlySelf: true });       // {3}
        }
      });
    }
    catch(err) 
    {
      throw new Error('add-notification.component.ts' + ' - handleInput() - ' + err.message);
    }
  }
  
// On change Notify
@ViewChild('roleindivi') SelRoleIndivi: MatSelect;
  onChangeNotify(event)
  {
    try
    {    
      this.notifytype = event;    
      var notifyType = 0;  
      if(this.notifytype == enumNotifyTypeText.Individual)
        notifyType = enumNotifyTypeItem.Individual;
      else if(this.notifytype == enumNotifyTypeText.Role)
        notifyType = enumNotifyTypeItem.Role;
      else if(this.notifytype == enumNotifyTypeText.StaffGroup)
        notifyType = enumNotifyTypeItem.StaffGroup;
      else if(this.notifytype == enumNotifyTypeText.ResidentGroup)
        notifyType = enumNotifyTypeItem.ResidentGroup;

      var notifyType_Item : notifyTypeItem =
      {
        siteId:this.SiteId,
        authKey: localStorage.getItem("Authkey"),
        nType:notifyType
      }
        
        this.getRoleOrIndividualList(notifyType_Item);
        this.SelRoleIndivi.options.forEach( (item : MatOption) => {item.deselect()});      
    }
    catch (err) {
      throw new Error('add-notification.component.ts' + ' - onChangeNotify() - ' + err.message);
    }
  }

// get Role/Invidual Data
getRoleOrIndividualList(notifytype):void {
  try
  {
    this.notificationService.getRoleOrIndividualList(notifytype).pipe(takeUntil(this._onDestroy))
      .subscribe((getRoleIndividualList : any[])=>{        
        if (getRoleIndividualList!=null && getRoleIndividualList!=undefined)
        { 
          this.RoleIndividualList = getRoleIndividualList;
        }
      });
    }
    catch (err) {
      throw new Error('add-notification.component.ts' + ' - getRoleOrIndividualList() - ' + err.message);
    }
  }

// close Notification Dialog
  public onCloseNotification = () => {
    this.thisDialogRef.close('Cancel');
    if(!SessionCheck(this.router))
    {
        return;
    }
   
  }

  public hasError = (controlName: string, errorName: string) =>{
    return this.notificationCreationForm.controls[controlName].hasError(errorName);
  }

  public createNotification = (notificationFormValue) => {   
    if(!SessionCheck(this.router))
    {
      this.thisDialogRef.close('Cancel');
        return;
    } 
    if (this.notificationCreationForm.valid && this.addNotifyflag) {          
        this.addNotifyflag = false;                        
          
          if(this.AlarmSubType_Name == "Low Batteries" || this.AlarmSubType_Name == "Lost Communication") // "Maintenance"
          {
            this.notificationCreationForm.controls["RepeatLevelNumber"].setValidators([Validators.required,Validators.max(30),Validators.min(1),Validators.pattern(appsettings.Number_Pattern)]);
            this.notificationCreationForm.controls["RepeatLevelNumber"].updateValueAndValidity();
            this.addNotifyflag = true;
            if(!this.notificationCreationForm.valid)
                return false; 
                
            this.notificationCreationForm.controls['RepeatLevelCycle'].setValidators([Validators.required,Validators.max(72),Validators.min(1),Validators.pattern(appsettings.Number_Pattern)]);
            this.notificationCreationForm.controls["RepeatLevelCycle"].updateValueAndValidity();
            this.addNotifyflag = true;
            if(!this.notificationCreationForm.valid)
                return false; 
          }
          else if(this.AlarmSubType_Name != "Low Batteries" && this.AlarmSubType_Name != "Lost Communication")
          {
            this.notificationCreationForm.controls["RepeatLevelNumber"].setValidators([Validators.required,Validators.max(30),Validators.min(1),Validators.pattern(appsettings.Number_Pattern)]);
            this.notificationCreationForm.controls["RepeatLevelNumber"].updateValueAndValidity();
            this.addNotifyflag = true;
            if(!this.notificationCreationForm.valid)
                return false; 
                
            this.notificationCreationForm.controls['RepeatLevelCycle'].setValidators([Validators.required,Validators.max(60),Validators.min(1),Validators.pattern(appsettings.Number_Pattern)]);
            this.notificationCreationForm.controls["RepeatLevelCycle"].updateValueAndValidity();
            this.addNotifyflag = true;
            if(!this.notificationCreationForm.valid)
                return false; 
          }
          
          if(this.AlarmSubType_Name == "Low Batteries" || this.AlarmSubType_Name == "Lost Communication")
          {
            this.notificationCreationForm.controls['TimeToEscalate'].setValidators([Validators.required,Validators.max(72),Validators.min(1),Validators.pattern(appsettings.Number_Pattern)]);
            this.notificationCreationForm.controls["TimeToEscalate"].updateValueAndValidity();
            this.addNotifyflag = true;
            if(!this.notificationCreationForm.valid)
                return false; 
          }
          else if(this.AlarmSubType_Name != "Low Batteries" && this.AlarmSubType_Name != "Lost Communication")
          {
            this.notificationCreationForm.controls['TimeToEscalate'].setValidators([Validators.required,Validators.max(60),Validators.min(1),Validators.pattern(appsettings.Number_Pattern)]);
            this.notificationCreationForm.controls["TimeToEscalate"].updateValueAndValidity();
            this.addNotifyflag = true;
            if(!this.notificationCreationForm.valid)
                return false; 
          }

         /* if(this.checkEscalate == false && this.checkRepeatLevel == false)
          {
            generateAlertMessage(this.dialog, "Please Select Repeat Level or Escalate");             
            this.addNotifyflag = true;         
            return;
          }
          else*/
            this.checkAlertForCampus(notificationFormValue);    
    }
  }
 
  checkAlertForCampus(notificationFormValue)
  {
    this.addNotifyflag = false;
    var checkalertItem : checkAlertItem =
     {
       siteId: this.SiteId,
       authKey: localStorage.getItem("Authkey"),
       campusId:parseInt(this.CampusId),
       eventId: parseInt(this.AlarmId),
       subTypeId:this.AlarmSubTypeId,
       buildId:parseInt(this.BuildingId),
       floorId:parseInt(this.FloorId),
       subzoneId:parseInt(this.SubZoneId)
     }
    this.notificationService.checkAlertForCampus(checkalertItem).pipe(takeUntil(this._onDestroy))
    .subscribe((apiresponse : any[])=>{
      if(apiresponse.toString() == "true")
      {        
        this.confirmation(notificationFormValue)
      }
      else
      {
        this.onSaveClicked(notificationFormValue);
      }
    });

  }
  confirmation(notificationFormValue)
  {
    try
    {
      var ConfirmMessageData = {
        ConfirmMessage: "Already escalated alerts won't be notified to this staff even though the staff will be added to the escalation.<br> Do you want to continue ?"                
      }     
      let dialogRef = this.dialog.open(ConfirmMessageComponent, {
        disableClose: true,
        width: 'auto',
        height: '220px',
        panelClass: 'myapp-no-padding-dialog',
        autoFocus: false,
        data: ConfirmMessageData
      });     
      dialogRef.afterClosed().subscribe(result => {
        if(result == "Yes")
        {              
          this.onSaveClicked(notificationFormValue);
        }
        else
        {
            this.addNotifyflag = true;
            this.thisDialogRef.close('Cancel');
            return;
        }
      });
    }
    catch(err)
    {
        throw new Error('add-notification.component.ts' + ' - confirmation() - ' + err.message);
    }   
  }

  // Add Notification
  private onSaveClicked = (notificationFormValue) => {
    try{
      
        this.addNotifyflag = false;
        var Escalatevalue;
        var TimetoEscalatevalue;                      
        var Escalatevalue;
        var RepeatLevelvalue;
        var TimetoEscalatevalue;
        var RepeatCyclevalue;
        var RepeatNumbervalue;
        
        // if(this.chkEscalateyesvalue == true)
        // {
        //   Escalatevalue = 1;
        //   TimetoEscalatevalue = notificationFormValue.TimeToEscalate;
        //   RepeatCyclevalue = 0;
        // }
        // else
        // {
        //   Escalatevalue = 0;
        //   TimetoEscalatevalue = 0;
        //   RepeatCyclevalue = notificationFormValue.RepeatCycleEscalate;
        // }
        
        if(this.checkEscalate == true)
        {
          Escalatevalue = 1;
          TimetoEscalatevalue = notificationFormValue.TimeToEscalate;
        }
        else
          Escalatevalue = 0;
          
        if(this.checkRepeatLevel == true)  
        {
          RepeatLevelvalue = 1;
          RepeatCyclevalue = notificationFormValue.RepeatLevelCycle;
          RepeatNumbervalue = notificationFormValue.RepeatLevelNumber;
          TimetoEscalatevalue = this.TimeEscalatevalue;
        }
        else
          RepeatLevelvalue = 0;
          
          
    /*    if(this.AlarmSubType_Name == "Low Batteries" || this.AlarmSubType_Name == "Lost Communication")
        {
          if(TimetoEscalatevalue < 1 || TimetoEscalatevalue > 72  && this.checkEscalate == true && this.checkRepeatLevel == false)
          {
            generateAlertMessage(this.dialog, "Please Enter Time To Escalation between 1 and 72");
            this.addNotifyflag = true;
            return false;
          }
        }
        else if(this.AlarmSubType_Name != "Low Batteries" && this.AlarmSubType_Name != "Lost Communication")
        {
          if(TimetoEscalatevalue < 1 || TimetoEscalatevalue > 60  && this.checkEscalate == true && this.checkRepeatLevel == false)
          {
            generateAlertMessage(this.dialog, "Please Enter Time To Escalation between 1 and 60");
            this.addNotifyflag = true;
            return false;
          }
        } 
        */
          
        let notification: AddNotification = {
          siteId:this.SiteId,
          authKey: localStorage.getItem("Authkey"),
          escalation: parseInt(this.Escalationlevel),
          eventType : parseInt(this.AlarmId),
          eventName :this.eventName, //notificationFormValue.EventName.toString(),
          timeToEscalate : parseInt(TimetoEscalatevalue),
          notify : notificationFormValue.notify.toString(),           
          notifyList : notificationFormValue.NotifyList.toString(),           
          alarmSubTypeId: this.AlarmSubTypeId,
          campusId : parseInt(this.CampusId),        
          campusName: this.campusName,
          buildingId: parseInt(this.BuildingId),
          floorId: parseInt(this.FloorId),
          subzoneId:parseInt(this.SubZoneId),
          needEscalate: parseInt(Escalatevalue),
          needRepeat: RepeatLevelvalue,
          repeatCycle: RepeatCyclevalue,
          repeatNumber: RepeatNumbervalue,          
        }       
        
          this.notificationService.addNotification(notification).pipe(takeUntil(this._onDestroy))
          .subscribe((apiresponse : NotificationForCreationResponse[])=>{     
            if (apiresponse["apiReturn"]!=null && apiresponse["apiReturn"]!=undefined)
            {       
        
              if(apiresponse["apiReturn"].toString() == "Success")
              { 
                var CheckAlertData = {
                  "IsAlertChanged": 0,
                  "IsAlertClicked": 0
                };
                this.alertSharedService.changeSharedCheckAlert(CheckAlertData);	
                CheckAlertData = {
                  "IsAlertChanged": 1,
                  "IsAlertClicked": 0
                };
                this.apiService.reloadNotification();              
                this.alertSharedService.changeSharedCheckAlert(CheckAlertData);	
                generateAlertMessage(this.dialog, 'Escalation data added successfully.')  
                                 
              }
              else if(apiresponse["apiReturn"].toString() == "Fail")
              {                
                this.addNotifyflag = true;
                generateAlertMessage(this.dialog, 'Escalation data added failed.')                 
              }
              else if(apiresponse["apiReturn"] == "Invalid Auth Key")
              {     
                  this.thisDialogRef.close('close');             
                  AuthFailedMessage(this.dialog,this.router);  
                  return;       
              }              
            }
            else
            {              
              this.addNotifyflag = true;
              generateAlertMessage(this.dialog, 'Escalation data added failed.')             
            }
              this.thisDialogRef.close('Confirm');
          });
    
         
      }
      catch (err) {
        throw new Error('add-notification.component.ts' + ' - onSaveClicked() - ' + err.message);
      }
     }

toggleRepeatLevel(event)
{
  if(event.checked == true)
  {
    this.checkRepeatLevel = true;
    this.notificationCreationForm.get('RepeatLevelNumber').enable();
    this.notificationCreationForm.get('RepeatLevelCycle').enable();
    
    if(this.checkEscalate == true)
      this.notificationCreationForm.get('TimeToEscalate').disable(); 
  }
  else if(event.checked == false)
  {
    this.checkRepeatLevel = false;
    this.RepeatCyclevalue = "";
    this.RepeatNumbervalue = "";
    this.notificationCreationForm.get('RepeatLevelNumber').disable();
    this.notificationCreationForm.get('RepeatLevelCycle').disable();
    
    if(this.checkEscalate == true)
      this.notificationCreationForm.get('TimeToEscalate').enable(); 
  }
}

toggleEscalate(event)
{
  if(event.checked == true)
  {
    this.checkEscalate = true;
    this.notificationCreationForm.get('TimeToEscalate').enable();  
    
    if(this.checkRepeatLevel == true)
    {      
      this.notificationCreationForm.get('TimeToEscalate').disable(); 
      this.calculateTimeEscalate();
    }
  }
  else if(event.checked == false)
  {
    this.checkEscalate = false;
    this.TimeEscalatevalue = "";
    this.notificationCreationForm.get('TimeToEscalate').disable();    
  }
}

mouseleaveRepeatCycle()
{
  if(this.checkEscalate == true && this.checkRepeatLevel == true)
    this.calculateTimeEscalate();
}

calculateTimeEscalate()
{
  var repeatNumbervalue = this.notificationCreationForm.value.RepeatLevelNumber;
  var repeatCyclevalue = this.notificationCreationForm.value.RepeatLevelCycle;
  if(repeatNumbervalue != "" && repeatCyclevalue != "" && /^[0-9]*$/.test(repeatCyclevalue) && /^[0-9]*$/.test(repeatNumbervalue))
    this.TimeEscalatevalue = (repeatNumbervalue * repeatCyclevalue) + parseInt(repeatCyclevalue); 
}

ngOnDestroy() {
  this._onDestroy.next();
  this._onDestroy.complete();
  }
}
